export default "{\n    \"servicedByText\": \"Servi par {{servicePartner}}\"\n}\n"